/**
 * Add override for dynamic columns that are not sortable
 */
PrimeFaces.widget.DataTable.prototype.shouldSort = function(event, column) {
  if (this.isEmpty()) {
    return false;
  }

  var target = $(event.target);
  if (target.closest(".ui-column-customfilter", column).length) {
    return false;
  }

  // add override for dynamic columns that are not sortable
  if ($(column).hasClass("column_notsortable")) {
    return false;
  }

  return target.is("th,span");
};

/**
 * Add override to trigger AutoComplete on paste from context menu
 */
PrimeFaces.widget.AutoComplete = PrimeFaces.widget.AutoComplete.extend({
  // overrides the key bindings
  bindKeyEvents: function() {
    this._super();

    var _self = this;

    // Additional event listener for property change events.
    // The event gets fired when values are pasted via context menu
    // or are typed into the input field. The timeout should prevent
    // this method from firing too many search requests, since
    // keydown triggers property change as well...
    this.input.bind("input propertychange", function() {
      var value = $(this).val();
      if (!value.length) {
        _self.hide();
      }

      if (value.length >= _self.cfg.minLength) {
        //Cancel the search request if user types within the timeout
        if (_self.timeout) {
          clearTimeout(_self.timeout);
        }

        _self.timeout = setTimeout(function() {
          _self.search(value);
        }, _self.cfg.delay);
      }
    });
  }
});

/** Function to add navigationFromLPList to localStorage **/
function addLocalStorage() {
  if (typeof Storage !== "undefined") {
    localStorage.setItem("navigationFromLPList", "true");
  }
}

//Function to calculate gray background height behind tabs
function showTabsTop(tabs_sec, tabs_hght) {
  var tabsSize = $("body").find("." + tabs_sec);
  if (tabsSize.length > 0) {
    $("body")
      .find(".tabs-top")
      .addClass("show");
    $("body")
      .find(".tabs-top")
      .css("min-height", tabsSize.height() + tabs_hght);
  }
}

/**
 * This function hides the tooltip
 */
function hideToolTip() {
  var tooltipBlock = $(".ui-tooltip");

  if (tooltipBlock.is(":visible")) {
    tooltipBlock.hide();
  }
}

/** Function to make buttons as Floating buttons on the pages where the scrolling goes too long. **/
var stickyFooter = new (function() {
  var self = this;
  //Function to enable/disable sticky footer on scroll event
  this.worker = function() {
    var winHt = $(window).height();
    var docHt = $(document).height();
    var winScrl = $(window).scrollTop();

    if (winScrl + winHt == docHt) {
      $(".esize-footer").addClass("float-footer");
      $(".float-buttons").css("border", "none");
      $(".float-buttons > table").addClass("border-n");
    } else {
      $(".esize-footer").removeClass("float-footer");
      $(".float-buttons").removeAttr("style");
      $(".float-buttons > table").removeClass("border-n");
    }
  };

  function waitForPause(ms, callback) {
    var timer;

    return function() {
      var self = this,
        args = arguments;
      clearTimeout(timer);
      timer = setTimeout(function() {
        callback.apply(self, args);
      }, ms);
    };
  }

  //To initiate the events
  this.start = function() {
    // wrap around your callback
    $(window).scroll(waitForPause(10, self.worker));
    $(window).resize(waitForPause(10, self.worker));
  };

  //To unbind events
  this.stop = function() {
    $(window).unbind("scroll", self.worker);
    $(window).unbind("resize", self.worker);
  };
})();

stickyFooter.start();

// Some tooltips have a \t character (coming from the index). Remove this tab
function updateTooltips() {
  $("[title]").each(function() {
    var elt = $(this);
    var title = elt.attr("title");
    title = title.replace("\t", " ");
    elt.attr("title", title);
  });
}

//Function to check if floating panel exists and accordingly to enable/disable sticky footer
function buttonsFloat() {
  var fltBtns = $(".launchpad").find(".float-buttons").length;
  if (fltBtns > 0 && $(window).height() < $(document).height()) {
    $(".float-buttons").addClass("float");
  } else {
    $(".float-buttons").removeClass("float");
  }
}
$(document).ready(buttonsFloat);
$(window).resize(buttonsFloat);
$(window).scroll(buttonsFloat);
/****************** Function to make buttons as Floating buttons ends here ****************/

// Function to toggle sidebar
var sidebarPanel;
var contentPanel;
var sideBarToggleButton;

function toggleSidebar(sideBarToggleButton) {
  sidebarPanel = sideBarToggleButton.parentNode;
  contentPanel = sidebarPanel.nextElementSibling;

  sideBarToggleButton.classList.toggle("expand");
  sidebarPanel.classList.toggle("column-3");
  sidebarPanel.classList.toggle("column-0");
}

/**
 * This function updates the title of the toggle button and
 * also sets the localStorage for the collapse state to true or false.
 */
function updateToggleTitle(toggleButton, ex, cl) {
  if (toggleButton.classList.contains("expand")) {
    toggleButton.title = ex;
    localStorage.setItem("collapsed", true);
  } else {
    toggleButton.title = cl;
    localStorage.setItem("collapsed", false);
  }
}

// Function to toggle the display of two elements by toggling 'hide' styleclass
function toggleElementsDisplay(firstElementId, secondElementId) {
  const firstElement = document.getElementById(firstElementId);
  const secondElement = document.getElementById(secondElementId);

  if (firstElement.classList.contains("hide")) {
    firstElement.classList.remove("hide");
  } else {
    firstElement.classList.add("hide");
  }
  if (secondElement.classList.contains("hide")) {
    secondElement.classList.remove("hide");
  } else {
    secondElement.classList.add("hide");
  }
}

/* This function toggles query-loading style class on an element */
function toggleQueryLoading(element) {
  if (element.classList.contains("query-loading")) {
    element.classList.remove("query-loading");
  } else {
    element.classList.add("query-loading");
  }
}

/**
 * This function checks whether the browser is Internet Explorer or Edge.
 */
function isInternetExplorerOrEdge() {
  return (
    navigator.appName === "Microsoft Internet Explorer" ||
    !!navigator.userAgent.match(/Edge|Trident|rv:11/) ||
    (typeof $.browser !== "undefined" && $.browser.msie === 1)
  );
}

/**
 * This function checks whether the browser is Internet Explorer.
 */
function isInternetExplorer() {
  return (
    navigator.appName === "Microsoft Internet Explorer" ||
    !!navigator.userAgent.match(/Trident|rv:11/) ||
    (typeof $.browser !== "undefined" && $.browser.msie === 1)
  );
}

/**
 * This function toggles the expand/collapse classes on the target.
 */
function toggleExpandCollapse(e) {
  const targetClass = e.classList;

  if (targetClass.contains("collapse-icon")) {
    targetClass.remove("collapse-icon");
    targetClass.add("expand-icon");
  } else {
    targetClass.remove("expand-icon");
    targetClass.add("collapse-icon");
  }
}

/* This function checks if the device is any mobile device */
function isMobileDevice() {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
    navigator.userAgent
  );
}

/* This function calculates the viewport height and sets it as viewport height of the
document element using the CSS variable '--mobileViewportHeight'. */
function updateMobileViewportHeight() {
  let viewportHeight = window.innerHeight * 0.01;

  document.documentElement.style.setProperty(
    "--mobileViewportHeight",
    viewportHeight + "px"
  );
}

/* Executing the updateMobileViewportHeight() function on window resize event
if the device is a mobile device. */
if (isMobileDevice) {
  window.addEventListener("resize", updateMobileViewportHeight);
}

/* Generic throttle function that catches and triggers last invocation */
const throttle = (func, limit) => {
  let lastFunc;
  let lastRan;
  return function() {
    const context = this;
    const args = arguments;
    if (!lastRan) {
      func.apply(context, args);
      lastRan = Date.now();
    } else {
      clearTimeout(lastFunc);
      lastFunc = setTimeout(function() {
        if (Date.now() - lastRan >= limit) {
          func.apply(context, args);
          lastRan = Date.now();
        }
      }, limit - (Date.now() - lastRan));
    }
  };
};

/* To toggle style class from an element */
function animateLoadingButton(button) {
	if (button.classList.contains('jsLoading')) {
		button.classList.remove('jsLoading');
	} else {
		button.classList.add('jsLoading');
	}
}

/* To toggle disabled attribute from an element */
function disableButton(button) {
	if (button.disabled === true) {
		button.disabled = false;
	} else {
		button.disabled = true;
	}
}

/* Function to identify an element with its ID and then performing action
to toggle style class and its disabled state. */
function initButtonLoading(elementId, isPrimefacesElement = true) {
	let buttonElement;

	if (!elementId) {
		return;
	}
	if (isPrimefacesElement) {
		buttonElement = PF(elementId).jq[0];
	} else {
		buttonElement = document.getElementById(elementId);
	}
	disableButton(buttonElement);
	animateLoadingButton(buttonElement);
}